import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { TextBoxOptions } from '../../Shared/Models/TextBoxOptions';
import { InputType } from '../../Shared/Enums/InputType';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { TranslateService } from '@ngx-translate/core';
import { ForceDirection } from '../../Shared/Enums/ForceDirection';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'BBSF-TextBox',
  templateUrl: './TextBox.component.html',
  styleUrls: ['./TextBox.component.scss']
})
export class TextboxComponent implements OnInit {


  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public TextControlHost: FormGroupDirective, private translate: TranslateService) {
    TextboxComponent.controlContainerstatic = this.controlContainer;

  }
  @Input() group: FormGroup;
  @Input() options: TextBoxOptions;
  @Output() OnChange = new EventEmitter();

  TextBoxFormControl: AbstractControl;
  MaskPattern: string;
  WordCount: number = 0;
  WordCountArray: number = 0;
  EmailValidationKey: string;
  PasswordComplexityHasNumber: string;
  ArabicLetterOnly: string;
  EnglishLetterOnly:string;
  PasswordComplexityHasCapitalLetter: string;
  PasswordComplexityHasSmallLetter: string;
  PasswordComplexityHasSpecialLetter: string
  MaxWordCountValidationKey: string
  IsShowWordCount: boolean = false;
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];
  currentLanguage = ""
  static showErrorOfInputs(errors: any) {

    const controlContainerstatic = TextboxComponent.controlContainerstatic;
    const formGroup = controlContainerstatic.control as FormGroup;
    for (const key in errors) {
      if (errors.hasOwnProperty(key)) {
        for (const iterator of errors[key]) {
          const formControl = formGroup.get(key) as FormControl;
          formControl.setErrors({ "FluentApi": iterator });
          formControl.markAsTouched();
        }
      }
    }
  }

  ngOnInit() {


    UtilityService.Translator.onLangChange.subscribe((lang) => {
      this.currentLanguage = lang.lang
    })
    UtilityService.isCreatedBefor = false
    if (this.options.MaskPattern != null && this.options.MaskPattern != "") {
      this.MaskPattern = this.options.MaskPattern
      this.options.Placeholder = this.MaskPattern
    }
    this.group.addControl(this.options.Name, new FormControl(''));
    this.TextBoxFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);
    this.TextBoxFormControl.setValue(this.options.Value);

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    this.getCustomErrorsMassages()
    switch (this.options.Type) {
      case InputType.Email:
        this.validationRules.push(Validators.compose([
          this.controlUtility.patternValidator(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, { EmailValidationKey: this.EmailValidationKey }),

        ]));
        break;
      case InputType.EID:
        this.MaskPattern = '000-0000-0000000-0';
        this.options.Placeholder = this.MaskPattern


        break;

      case InputType.Number:
        this.validationRules.push(Validators.pattern('^[0-9]+(\.?[0-9]+)?$'));
        if (this.options.NumberRange != null) {

          this.validationRules.push(Validators.min(this.options.NumberRange.From));
          this.validationRules.push(Validators.max(this.options.NumberRange.To));
        }
        break;
      case InputType.Password:
        if (!this.options.RemoveDefaultPasswordValidation) {
          this.validationRules.push(Validators.compose([
            this.controlUtility.patternValidator(/\d/, { PasswordComplexityHasNumber: this.PasswordComplexityHasNumber }),
            this.controlUtility.patternValidator(/[A-Z]/, { PasswordComplexityHasCapitalLetter: this.PasswordComplexityHasCapitalLetter }),
            this.controlUtility.patternValidator(/[a-z]/, { PasswordComplexityHasSmallLetter: this.PasswordComplexityHasSmallLetter }),
            this.controlUtility.patternValidator(/[!@#$%^&*(),.?":{}|<>]/, { PasswordComplexityHasSpecialLetter: this.PasswordComplexityHasSpecialLetter }),
            Validators.minLength(8),
          ]));
        }
        break;
    }
    if (this.options.ForceDirection==ForceDirection.Arabic) 
    {
      this.validationRules.push(Validators.compose([
        this.controlUtility.patternValidator(/[\u0621-\u064A]+/, { ArabicLetterOnly: this.ArabicLetterOnly }),
         
      ]));
      
    }
    if (this.options.ForceDirection==ForceDirection.English) 
    {
      this.validationRules.push(Validators.compose([
        this.controlUtility.patternValidator(/^[\x00-\x7F]*$/, { EnglishLetterOnly: this.EnglishLetterOnly }),
         
      ]));
      
    }
    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }
    if (this.options.MinLength > 0) {
      this.validationRules.push(Validators.minLength(this.options.MinLength));
    }
    if (this.options.MaxLength > 0) {
      this.validationRules.push(Validators.maxLength(this.options.MaxLength));
    }
    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    this.TextBoxFormControl.setValidators(this.validationRules);
    this.TextBoxFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.TextBoxFormControl.disable();
    }

    this.TextControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })

  }


  ngAfterViewInit(): void {
    this.controlUtility.setAttributeForControl(this.options)
  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {

    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }

  getInputType(type: number) {
    return this.controlUtility.getInputType(type)
  }

  trimControlValue() {
    let OrignalValue = this.controlUtility.trimControlValue(this.TextBoxFormControl.value);
    this.TextBoxFormControl.patchValue(OrignalValue)

  }

  copyInputMessage(inputElement) {
    this.controlUtility.CopyInputMessage(inputElement)
  }

  getCustomErrorsMassages() {
    this.EmailValidationKey = UtilityService.getResourceValue("EmailValidationKey");
    this.PasswordComplexityHasCapitalLetter = UtilityService.getResourceValue("PasswordComplexityHasCapitalLetter");
    this.PasswordComplexityHasNumber = UtilityService.getResourceValue("PasswordComplexityHasNumber");
    this.PasswordComplexityHasSmallLetter = UtilityService.getResourceValue("PasswordComplexityHasSmallLetter");
    this.PasswordComplexityHasSpecialLetter = UtilityService.getResourceValue("PasswordComplexityHasSpecialLetter");
    this.MaxWordCountValidationKey = UtilityService.getResourceValue("MaxWordCountValidationKey");
    this.ArabicLetterOnly = UtilityService.getResourceValue("ArabicLetterOnly");
    this.EnglishLetterOnly = UtilityService.getResourceValue("EnglishLetterOnly");


  }

  onTextChange() {

    if (this.TextBoxFormControl.value == "") {
      this.WordCountArray = 0;
      this.WordCount = 0;
    }

    else {
      this.WordCountArray = this.TextBoxFormControl.value.split(" ").length;
      if (this.WordCountArray > 0) {
        if (this.WordCountArray > this.options.MaxWordCount) {
          this.WordCount = this.options.MaxWordCount;
          this.TextBoxFormControl.setErrors({ MaxWordCountValidationKey: this.options.MaxWordCount });
          this.TextBoxFormControl.markAsTouched();
          this.TextBoxFormControl.invalid;
        }
        else {
          this.WordCount = this.WordCountArray;

        }

      }
    }
    this.OnChange.emit(this.TextBoxFormControl.value)
  }

  showWordCount(value: boolean) {
    this.IsShowWordCount = value
  }
  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.TextBoxFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.TextBoxFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.TextBoxFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.TextBoxFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.TextBoxFormControl)
  }
}


